import BaseModelAPI from '../BaseModelAPI';

export default class ScrapExecution extends BaseModelAPI {
	static entity = 'scrapexecution';
	static entityName = 'scrapexecution';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.scrapExecutionNumber = '';
		this.customerId = '';
		this.customerCode = '';
		this.customer = {};
		this.vendorScrapId = '';
		this.vendorScrapCode = '';
		this.vendorScrap = {};
		this.scrapExecutionDate = '';
		this.beratScrap = 0;
		this.scrapExecutionDetail = []
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async printBeritaAcara(this_, modelId) {
		return this_.$http.get(`${this.entityName}/printberitaacara/${modelId}`)
			.then(response => {
				if (response.data) {
					return response.data;
				}
				return null;
			}).catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

}